module.exports = fox._r("images/promo/icon-yt.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/icon-yt.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/icon-yt.png
// module id = 167
// module chunks = 2